import { productTourTypes } from './actionTypes'
import { ProductTourActions, ProductTourState } from './types'

const initialState: ProductTourState = {
    runProductTour: false,
    stepIndex: 0,
    step: [],
}

export default (
    state = initialState,
    action: ProductTourActions,
): ProductTourState => {
    switch (action.type) {
        case productTourTypes.SET_RUN:
            return {
                ...state,
                runProductTour: action.payload,
            }
        case productTourTypes.SET_STEP_INDEX:
            return {
                ...state,
                stepIndex: action.payload,
            }
        case productTourTypes.SET_STEP:
            return {
                ...state,
                step: action.payload,
            }
        default:
            return {
                ...state,
            }
    }
}
